export function formatPhoneNumber(phoneNumberString?: string) {
	const formattedNumber = ('' + phoneNumberString)
		.replace(/\D/g, '')
		.substring(1);
	return formattedNumber;
}

export function phoneNumberWithCountryCode(phoneNumber?: string) {
	if (!phoneNumber) return phoneNumber;
	const updatedNumber = phoneNumber?.split('+1')?.[1] || phoneNumber;
	const currentValue = updatedNumber.replace(/[^\d]/g, '');
	const cvLength = currentValue.length;
	if (updatedNumber.length) {
		if (cvLength === 0) return '';
		if (cvLength < 4) {
			if (!updatedNumber.includes(')')) {
				return `+1 (${currentValue}`;
			}
			return `+1 (${currentValue})`;
		}
		if (cvLength < 7)
			return `+1 (${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
		return `+1 (${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
	}
}
